export default "__VITE_ASSET__CQp4KTff__"